import gql from "graphql-tag";
import { headerSlideFragment } from "../fragments/headerSlide";

export default gql`
  mutation resetHeaderSlider($input: ResetHeaderSliderInput!) {
    resetHeaderSlider(input: $input) {
      ...HeaderSlide
    }
  }
  ${headerSlideFragment}
`;
